import Hardware from 'src/models/hardware/Hardware'
import KitchenDisplay from 'src/models/kitchen-display/KitchenDisplay'
import LocationGroup from 'src/models/location/LocationGroup'
import Model, { encoders, ID, Integer, MODEL_LEVEL } from 'src/models/Model'
import RegisterStation from 'src/models/register/RegisterStation'

export const fastPrepMinutes = 3

export const PRINTER_SOURCE_TYPES = {
  HARDWARE: 'hardware',
  KITCHEN_DISPLAY: 'kitchen_display',
  REGISTER: 'register'
}
PRINTER_SOURCE_TYPES.ALL = _.values(PRINTER_SOURCE_TYPES)

export default class Location extends Model {
  static name = 'Location'

  static deletable = true
  static paginate = true
  static isConfiguration = true

  static versioned = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Kitchen, Model.permissionCategories.Concession, Model.permissionCategories.PointOfSale, Model.permissionCategories.HardwareAndRegisterStation]
  static manageAction = ['Manage', 'ManagePrinterRouting']

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      locationGroup: {
        type: LocationGroup,
        default: null,
        encode: encoders.hasOne
      },
      action: {
        type: String,
        default: null,
        input: true
      },
      orderIdForPrinting: {
        type: ID,
        default: null,
        input: true
      },
      displayOrder: {
        type: Integer,
        required: true,
        default: 100
      },
      deliverFastPrepItemsToLocalRegisters: {
        type: Boolean,
        default: true
      },
      deliverFastPrepItemsToRemoteRegisters: {
        type: Boolean,
        default: true
      },
      deliverReadyToServeItemsToRemoteRegisters: {
        type: Boolean,
        default: true
      },
      printerSource: {
        type: String,
        default: PRINTER_SOURCE_TYPES.HARDWARE
      },
      printer: {
        type: Hardware,
        default: null,
        encode: encoders.hasOne,
        reference: true
      },
      registerStation: {
        type: RegisterStation,
        default: null,
        encode: encoders.hasOne,
        reference: true
      },
      kitchenDisplay: {
        type: KitchenDisplay,
        default: null,
        encode: encoders.hasOne,
        reference: true
      },
      hasPickPrepPrinter: {
        type: Boolean,
        default: false,
        output: true
      },
      disableAutoPickPrepPrinting: {
        type: Boolean,
        default: false
      }
    }

    this.computed = {
      inventoryStrategyEntityDisplayName () {
        if (this.locationGroup?.site && this.locationGroup?.site.id !== this.configuration.currentSite.id) {
          return `${this.locationGroup.site.name} - ${this.name}`
        } else {
          if (_.first(this.configuration.currentSite.activeInventoryStrategy?.locations.data)?.id === this.id) {
            return `${this.name} (Default ${this.humanTypeName})`
          } else {
            return `${this.name} (${this.humanTypeName})`
          }
        }
      },
      displayName () {
        if (this.site && this.site.id !== this.configuration.currentSite.id) {
          return `${this.site.name} - ${this.name}`
        } else if (this.locationGroup) {
          return `${this.name} - ${this.locationGroup.name}`
        } else {
          return this.name
        }
      },
      resolvedPrinter () {
        if (this.printerSource === PRINTER_SOURCE_TYPES.HARDWARE) {
          return this.printer
        } else if (this.printerSource === PRINTER_SOURCE_TYPES.REGISTER) {
          return this.registerStation
        } else if (this.printerSource === PRINTER_SOURCE_TYPES.KITCHEN_DISPLAY) {
          return this.kitchenDisplay
        } else {
          return null
        }
      },
      isValidPrintLocation () {
        return this.disableAutoPickPrepPrinting || this.hasPickPrepPrinter
      }
    }
  }

  async printPickPrep (orderId) {
    this.action = 'print_pick_prep'
    this.orderIdForPrinting = orderId

    try {
      await this.save()
    } catch (error) {
      console.log(error)
    } finally {
      this.resetField('action')
      this.resetField('orderIdForPrinting')
    }
  }
}
